const e = {
  MuiButtonBase: {
    defaultProps: {
      disableRipple: !0,
      disableTouchRipple: !0
    }
  }
};
export {
  e as default
};
